import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { EmployeeForm } from './../forms'
import { Dashboard } from './../layouts'
import axios from './../plugins/axios'

const styles = theme => ({
    //
})

class EmployeeUpdate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: 'Ажилчид',
            key: shortid.generate(),
            name: '',
            position: '',
            image: ''
        }
    }

    componentWillMount = () => {
        this.fetchData()
    }

    fetchData = async () => {
        const { match } = this.props
        const { id } = match.params

        try {
            const { data } = await axios.get(`/employees/${id}`, { progress: true})

            this.setState({
                key: shortid.generate(),
                name: data.name,
                position: data.position,
                image: data.image
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            title,
            key,
            name,
            position,
            image
        } = this.state
        const { match } = this.props
        const { id } = match.params
        return (
            <Dashboard title={title}>
                <EmployeeForm
                    key={key}
                    path={`employees/${id}`}
                    method="put"
                    name={name}
                    position={position}
                    image={image}
                    message="Амжилттай шинэчлэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(EmployeeUpdate)
